import { useEffect, useRef, useState, useContext } from "react";
import PropTypes from "prop-types";
import { FontSizeContext } from "../../context/fontSizeContext";
import ClientstoriesData from "../../data/clientstories.json";

const ClientstoriesContainer = ({ classOption = "section-pb" }) => {
    const { fontSize } = useContext(FontSizeContext);
    const textRefs = useRef([]);
    const [defaultSizes, setDefaultSizes] = useState([]);
    const [videoSrc, setVideoSrc] = useState("");
    const [videoName, setVideoName] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false); // State to control modal visibility
    const modalRef = useRef(null);
    const closeButtonRef = useRef(null);
    const previousFocusRef = useRef(null);
    const modalContentRef = useRef(null);
    const scrollYRef = useRef(0);

    const openModal = (param, name) => (e) => {
        previousFocusRef.current = e.currentTarget;
        setIsModalOpen(true);
        setVideoSrc(param);
        setVideoName(name);
    };
    const closeModal = () => setIsModalOpen(false);

    useEffect(() => {
        if (isModalOpen) {
            // setVideoSrc(
            //     "https://www.youtube.com/embed/oUZnCGZpLyU?si=hjVgsQtFHyANoGb6&autoplay=1"
            // );
            scrollYRef.current = window.scrollY;
            document.body.style.position = "fixed";
            document.body.style.top = `-${scrollYRef.current}px`;
            document.body.style.left = "0";
            document.body.style.right = "0";
            document.body.style.width = "100%";

            const focusTimeout = setTimeout(() => {
                closeButtonRef.current?.focus();
            }, 100);
            return () => clearTimeout(focusTimeout);
        } else {
            document.body.style.position = "";
            document.body.style.top = "";
            document.body.style.left = "";
            document.body.style.right = "";
            document.body.style.width = "";
            window.scrollTo(0, scrollYRef.current);

            previousFocusRef.current?.focus();
            setVideoSrc(""); // Stop video when modal is closed
        }

        return () => {
            document.body.style.position = "";
            document.body.style.top = "";
            document.body.style.left = "";
            document.body.style.right = "";
            document.body.style.width = "";
        };
    }, [isModalOpen]);

    useEffect(() => {
        if (!isModalOpen) return;

        const modalNode = modalContentRef.current;
        if (!modalNode) return;

        const focusableSelector =
            'a[href], button:not([disabled]), textarea, input, select, iframe, [tabindex]:not([tabindex="-1"])';

        const getFocusable = () =>
            Array.from(modalNode.querySelectorAll(focusableSelector)).filter(
                (el) => el.offsetParent !== null
            );

        const handleKeyDown = (e) => {
            if (e.key === "Escape") {
                closeModal();
                return;
            }

            if (e.key !== "Tab") return;

            const focusable = getFocusable();
            if (focusable.length === 0) return;

            const first = focusable[0];
            const last = focusable[focusable.length - 1];
            const active = document.activeElement;

            if (e.shiftKey) {
                if (active === first || !modalNode.contains(active)) {
                    e.preventDefault();
                    last.focus();
                }
            } else {
                if (active === last || !modalNode.contains(active)) {
                    e.preventDefault();
                    first.focus();
                }
            }
        };

        // Safety net: if focus ever ends up outside the modal, pull it back
        const handleFocusIn = (e) => {
            if (!modalNode.contains(e.target)) {
                closeButtonRef.current?.focus();
            }
        };

        document.addEventListener("keydown", handleKeyDown);
        document.addEventListener("focusin", handleFocusIn);

        return () => {
            document.removeEventListener("keydown", handleKeyDown);
            document.removeEventListener("focusin", handleFocusIn);
        };
    }, [isModalOpen]);

    const sceneEl = useRef(null);

    const adjustFontSize = (change) => {
        textRefs.current.forEach((element, index) => {
            if (element) {
                const computedStyle = window.getComputedStyle(element);
                const currentSize = parseFloat(computedStyle.fontSize);
                const newSize = currentSize + change;
                element.style.fontSize = `${newSize}px`;
            }
        });
    };

    const resetFontSize = () => {
        textRefs.current.forEach((element, index) => {
            if (element && defaultSizes[index] !== null) {
                element.style.fontSize = `${defaultSizes[index]}px`;
            }
        });
    };

    useEffect(() => {
        const sizes = textRefs.current.map((element) => {
            if (element) {
                const computedStyle = window.getComputedStyle(element);
                return parseFloat(computedStyle.fontSize);
            }
            return null;
        });
        setDefaultSizes(sizes);

        // const parallaxInstance = new Parallax(sceneEl.current, {
        //     relativeInput: true,
        // });

        // parallaxInstance.enable();

        // return () => parallaxInstance.disable();
    }, []);

    useEffect(() => {
        if (fontSize == 0) {
            resetFontSize();
        } else {
            adjustFontSize(fontSize);
        }
    }, [fontSize]);

    return (
        <div className={`testimonial-section position-relative ${classOption}`}>
            <div className="m-10">
                <div className="row justify-content-around">
                    {ClientstoriesData &&
                        ClientstoriesData.map((data, key) => {
                            return data.id % 2 != 0 ? (
                                <div
                                    className="col-xl-6 col-lg-6 col-md-6 col-12 mb-5"
                                    key={key}
                                >
                                    <div
                                        className={
                                            data.class +
                                            " radius-box p-3 y-scroll-height"
                                        }
                                    >
                                        <div className="row mb-1 item-desk">
                                            <img
                                                src={
                                                    process.env.PUBLIC_URL +
                                                    data.authorThumb
                                                }
                                                alt=""
                                                width={"30%"}
                                                className="radius-box"
                                            />
                                        </div>
                                        <div className="d-flex justify-content-evenly">
                                            <img
                                                src={
                                                    process.env.PUBLIC_URL +
                                                    data.authorThumb
                                                }
                                                alt=""
                                                width={"30%"}
                                                className="radius-box y-border item-mobile"
                                            />
                                            <div className="align-self-center m-4 text-center">
                                                <h2 className="title text-center">
                                                    <b>{data.name}</b>
                                                </h2>
                                                <p>
                                                    {" "}
                                                    <b>{data.city}</b>
                                                </p>
                                                <button
                                                    className="btn btn-sm btn-primary btn-hover-primary mt-3"
                                                    type="button"
                                                    aria-label={`Click to Play story of ${data.name}`}
                                                    onClick={openModal(
                                                        data.video,
                                                        data.name
                                                    )}
                                                >
                                                    Click to Play{" "}
                                                    <i
                                                        className="fa fa-play-circle fa-lg"
                                                        aria-hidden="true"
                                                    ></i>
                                                </button>

                                                {/* <img
                                                alt="NeoPic"
                                                src={
                                                    process.env.PUBLIC_URL +
                                                    "/images/icon/play.svg"
                                                }
                                                width="15%"
                                                className=" mt-3"
                                                style={{ marginLeft: "-19px" }}
                                            /> */}
                                            </div>
                                        </div>
                                        <div className="mt-3">
                                            {/* <h4 className="title text-left m-4">
                                            <b>
                                                <u>{data.name}</u>
                                            </b>
                                        </h4> */}
                                            {data.details &&
                                                data.details.map(
                                                    (details, keyd) => {
                                                        return (
                                                            <p
                                                                key={keyd}
                                                                className="text-dark"
                                                                style={{
                                                                    fontSize:
                                                                        "13px",
                                                                }}
                                                                dangerouslySetInnerHTML={{
                                                                    __html: details,
                                                                }}
                                                            ></p>
                                                        );
                                                    }
                                                )}
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div
                                    className="col-xl-6 col-lg-6 col-md-6 col-12 mb-5"
                                    key={key}
                                >
                                    <div
                                        className={
                                            data.class +
                                            " radius-box p-3 y-scroll-height"
                                        }
                                    >
                                        <div className="row mb-1 item-desk">
                                            <img
                                                src={
                                                    process.env.PUBLIC_URL +
                                                    data.authorThumb
                                                }
                                                alt=""
                                                width={"30%"}
                                                className="radius-box"
                                            />
                                        </div>
                                        <div className="d-flex justify-content-evenly">
                                            <img
                                                src={
                                                    process.env.PUBLIC_URL +
                                                    data.authorThumb
                                                }
                                                alt=""
                                                width={"30%"}
                                                className="radius-box y-border item-mobile"
                                            />
                                            <div className="align-self-center m-4 text-center">
                                                <h2 className="title text-center">
                                                    <b>{data.name}</b>
                                                </h2>
                                                <p>
                                                    {" "}
                                                    <b>{data.city}</b>
                                                </p>
                                                <button
                                                    className="btn btn-sm btn-primary btn-hover-primary mt-3"
                                                    type="button"
                                                    aria-label={`Click to Play story of ${data.name}`}
                                                    onClick={openModal(
                                                        data.video,
                                                        data.name
                                                    )}
                                                >
                                                    Click to Play{" "}
                                                    <i
                                                        className="fa fa-play-circle fa-lg"
                                                        aria-hidden="true"
                                                    ></i>
                                                </button>

                                                {/* <img
                                                alt="NeoPic"
                                                src={
                                                    process.env.PUBLIC_URL +
                                                    "/images/icon/play.svg"
                                                }
                                                width="15%"
                                                className=" mt-3"
                                                style={{ marginLeft: "-19px" }}
                                            /> */}
                                            </div>
                                        </div>
                                        <div className="mt-3">
                                            {/* <h4 className="title text-left m-4">
                                            <b>
                                                <u>{data.name}</u>
                                            </b>
                                        </h4> */}
                                            {data.details &&
                                                data.details.map(
                                                    (details, keyd) => {
                                                        return (
                                                            <p
                                                                key={keyd}
                                                                className="text-dark"
                                                                style={{
                                                                    fontSize:
                                                                        "13px",
                                                                }}
                                                                dangerouslySetInnerHTML={{
                                                                    __html: details,
                                                                }}
                                                            ></p>
                                                        );
                                                    }
                                                )}
                                        </div>
                                        {/* <h4 className="title text-center m-4">
                                        <b>
                                            <u>{data.name}</u>
                                        </b>
                                    </h4> */}
                                        {/* {data.details &&
                                        data.details.map((details, keyd) => {
                                            return (
                                                <p
                                                    key={keyd}
                                                    className="text-dark"
                                                    style={{ fontSize: "13px" }}
                                                    dangerouslySetInnerHTML={{
                                                        __html: details,
                                                    }}
                                                ></p>
                                            );
                                        })} */}
                                    </div>
                                </div>
                            );
                        })}
                </div>
            </div>
            {isModalOpen && (
                <div
                    className="modal-backdrop"
                    style={{
                        background: "rgba(0, 0, 0, 0.5)",
                        backdropFilter: "blur(5px)",
                    }}
                ></div>
            )}
            <div
                ref={modalRef}
                className={`modal ${isModalOpen ? "show" : ""}`}
                style={{
                    display: isModalOpen ? "block" : "none",
                    background: "#b5c4a875",
                }}
            >
                <div
                    className="modal-dialog modal-dialog-centered modal-dialog-scrollable"
                    style={{
                        maxWidth: "1000px",
                        overflow: "visible",
                        borderRadius: "0.75em",
                    }} // Adjust modal width
                >
                    <div
                        ref={modalContentRef}
                        className="modal-content"
                        style={{ position: "relative", overflow: "visible" }}
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby={`Video of ${videoName}`}
                        tabIndex="-1"
                    >
                        <div
                            id={`Video of ${videoName}`}
                            className="visually-hidden"
                        >
                            {`Video of ${videoName}`}
                        </div>
                        {/* Close button */}
                        <button
                            ref={closeButtonRef}
                            type="button"
                            className="btn-close custom-close-button"
                            style={{
                                position: "absolute",
                                top: "-15px",
                                right: "-5px",
                                backgroundColor: "#fff",
                                border: "1px solid #ccc",
                                borderRadius: "50%",
                                padding: "5px",
                                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                                zIndex: 1050,
                                width: "25px",
                                height: "25px",
                            }}
                            aria-label="Close"
                            onClick={closeModal}
                        ></button>

                        <div className="modal-body padding-0">
                            {videoSrc && (
                                <iframe
                                    width="100%"
                                    height="450" // Adjust height as needed
                                    src={videoSrc}
                                    title="YouTube video player"
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                    referrerPolicy="strict-origin-when-cross-origin"
                                    allowFullScreen
                                ></iframe>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

ClientstoriesContainer.propTypes = {
    classOption: PropTypes.string,
};

export default ClientstoriesContainer;
